import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {CalendarsPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {VisualParticipantModel} from '../../../models/api/visualParticipantModel';
import {CalendarEventData} from '../../../store/panels/calendars/calendarsPanelSelectors';
import {SideCalendarsHeader} from '../header/sideCalendarsHeader';
import {CalendarEventViewerHeaderButtonsContainer} from './calendarEventViewerHeaderButtonsContainer';

/*
 * Props.
 */

interface SideCalendarEventViewerHeaderProps {
  panelId: CalendarsPanelId;
  calendarEventData: CalendarEventData;
  visualParticipants: ReadonlyArray<VisualParticipantModel>;
  onEditClick: () => void;
  onBackClick: () => void;
}

/*
 * Component.
 */

export const SideCalendarEventViewerHeader: FC<SideCalendarEventViewerHeaderProps> = (props) => {
  const {panelId, onBackClick, calendarEventData, visualParticipants, onEditClick} = props;
  return (
    <SideCalendarsHeader
      title={<Trans id="calendar-header-eventdetails">Event details</Trans>}
      onBackClick={onBackClick}
    >
      <CalendarEventViewerHeaderButtonsContainer
        panelId={panelId}
        calendarEventData={calendarEventData}
        visualParticipants={visualParticipants}
        onEditClick={onEditClick}
        numberOfPrimaryButtons={3}
      />
    </SideCalendarsHeader>
  );
};
